import { useState, useEffect, useCallback } from 'react';
import { API_BASE_URL } from '../config';

export const useGalleryData = (hallId) => {
  const [showrooms, setShowrooms] = useState([]);
  const [items, setItems] = useState([]);
  const [placements, setPlacements] = useState([]);
  const [currentShowroomId, setCurrentShowroomId] = useState(hallId ? parseInt(hallId) : 1);
  const [loading, setLoading] = useState(true);
  const [sceneLoading, setSceneLoading] = useState(false);

  // Derived state
  const currentShowroom = Array.isArray(showrooms) ? showrooms.find(room => room.id === currentShowroomId) : null;

  const fetchData = useCallback(async () => {
    try {
      const [showroomsRes, itemsRes, placementsRes] = await Promise.all([
        fetch(`${API_BASE_URL}/showrooms`),
        fetch(`${API_BASE_URL}/items`),
        fetch(`${API_BASE_URL}/placements`)
      ]);

      const [showroomsData, itemsData, placementsData] = await Promise.all([
        showroomsRes.json(),
        itemsRes.json(),
        placementsRes.json()
      ]);

      console.log(`🏛️ Loaded data - Showrooms: ${showroomsData?.length}, Items: ${itemsData?.length}, Placements: ${placementsData?.length}`);
      
      setShowrooms(Array.isArray(showroomsData) ? showroomsData : []);
      setItems(Array.isArray(itemsData) ? itemsData : []);
      setPlacements(Array.isArray(placementsData) ? placementsData : []);

      // Only set default room if no URL hallId was provided
      if (Array.isArray(showroomsData) && showroomsData.length > 0 && !hallId) {
//        console.log(`🎯 No URL room specified, defaulting to first room: ${showroomsData[0].id}`);
        setCurrentShowroomId(showroomsData[0].id);
      } else if (hallId) {
//        console.log(`🎯 URL room specified: ${hallId}, validating...`);
        const roomId = parseInt(hallId);
        const roomExists = showroomsData?.find(r => r.id === roomId);
        if (roomExists) {
          console.log(`✅ Room ${roomId} exists, setting as current`);
          setCurrentShowroomId(roomId);
        } else {
          console.warn(`⚠️ Room ${roomId} not found, falling back to first room`);
          setCurrentShowroomId(showroomsData[0]?.id || 1);
        }
      }
    } catch (error) {
      console.error('Failed to fetch data:', error);
    } finally {
      setLoading(false);
    }
  }, [hallId]);

  // Handle URL params - this is now handled in fetchData to avoid double loading

  // Fetch data on mount
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    showrooms,
    items,
    placements,
    currentShowroomId,
    setCurrentShowroomId,
    currentShowroom,
    loading,
    sceneLoading,
    setSceneLoading
  };
};